import React from 'react';
import './termsandconditions.css';
import { FaRegFileAlt, FaShieldAlt, FaLock, FaUserShield, FaRegClock } from 'react-icons/fa';

function TermsAndConditions() {
  return (
    <div className="terms-container">
      <header className="terms-header">
        <div className="header-content">
          <h1><FaRegFileAlt /> Terms & Conditions</h1>
          <p className="subtitle">Ceylon Eye Care Optometric Association</p>
          <p className="last-updated"><FaRegClock /> Last updated: {new Date().toLocaleDateString()}</p>
        </div>
      </header>

      <main className="terms-content">
        <section className="intro-section">
          <div className="security-badges">
            <div className="badge">
              <FaShieldAlt className="badge-icon" />
              <span>Privacy Protected</span>
            </div>
            <div className="badge">
              <FaLock className="badge-icon" />
              <span>Secure Compliance</span>
            </div>
            <div className="badge">
              <FaUserShield className="badge-icon" />
              <span>Member Focused</span>
            </div>
          </div>
          <p className="intro-text">
            Welcome to the Ceylon Eye Care Optometric Association. These terms and conditions outline the rules and regulations for the use of our services and membership benefits. By accessing this association, we assume you accept these terms and conditions in full.
          </p>
        </section>

        <div className="terms-grid">
          <section className="terms-section">
            <h2><span className="section-number">1.</span> Membership Terms</h2>
            <div className="section-content">
              <h3>1.1 Eligibility</h3>
              <p>Membership is open to all qualified optometrists registered with the Sri Lanka Optometric Council. Applicants must submit proof of qualifications and professional registration.</p>
              
              <h3>1.2 Membership Fees</h3>
              <p>Annual membership fees are due on January 1st each year. Late payments may incur additional charges or suspension of membership benefits.</p>
              
              <h3>1.3 Code of Conduct</h3>
              <p>All members must adhere to the professional code of conduct established by the Sri Lanka Optometric Council and this Association.</p>
            </div>
          </section>

          <section className="terms-section">
            <h2><span className="section-number">2.</span> Intellectual Property</h2>
            <div className="section-content">
              <h3>2.1 Ownership</h3>
              <p>All content, logos, and materials provided by the Association are the property of Ceylon Eye Care Optometric Association and protected by copyright laws.</p>
              
              <h3>2.2 Usage Rights</h3>
              <p>Members may use Association materials for professional purposes only. Commercial use requires written permission.</p>
            </div>
          </section>

          <section className="terms-section">
            <h2><span className="section-number">3.</span> Privacy Policy</h2>
            <div className="section-content">
              <h3>3.1 Data Collection</h3>
              <p>We collect professional information necessary for membership verification and service provision. Personal data is handled in accordance with Sri Lankan privacy laws.</p>
              
              <h3>3.2 Data Usage</h3>
              <p>Member information will only be used for Association purposes and will not be shared with third parties without consent, except as required by law.</p>
            </div>
          </section>

          <section className="terms-section">
            <h2><span className="section-number">4.</span> Event Participation</h2>
            <div className="section-content">
              <h3>4.1 Registration</h3>
              <p>Event registration is binding. Cancellations must be made at least 7 days prior for refund eligibility.</p>
              
              <h3>4.2 Continuing Education</h3>
              <p>CE credits will be awarded according to participation and completion of required assessments.</p>
            </div>
          </section>

          <section className="terms-section">
            <h2><span className="section-number">5.</span> Liability</h2>
            <div className="section-content">
              <h3>5.1 Professional Advice</h3>
              <p>The Association provides educational resources but does not replace professional clinical judgment. Members are responsible for their own practice decisions.</p>
              
              <h3>5.2 Website Use</h3>
              <p>While we strive for accuracy, we cannot guarantee all website content is error-free or current at all times.</p>
            </div>
          </section>

          <section className="terms-section">
            <h2><span className="section-number">6.</span> Amendments</h2>
            <div className="section-content">
              <h3>6.1 Policy Changes</h3>
              <p>These terms may be updated periodically. Members will be notified of significant changes via email and website announcements.</p>
              
              <h3>6.2 Governing Law</h3>
              <p>These terms are governed by the laws of Sri Lanka. Any disputes shall be resolved in Colombo courts.</p>
            </div>
          </section>
        </div>

        <section className="acceptance-section">
          <h2>Acceptance of Terms</h2>
          <p>By becoming a member of Ceylon Eye Care Optometric Association, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.</p>
          <p>For questions regarding these terms, please contact our membership committee at <a href="mailto:info@optometryassociation.lk">info@optometryassociation.lk</a>.</p>
        </section>
      </main>


    </div>
  );
}

export default TermsAndConditions;